import { GraphQLClient } from 'graphql-request';

export const graphQLFetcher = <T, V extends Record<string, any> = {}>({
  query,
  variables,
  headers,
  signal,
}: {
  query: string;
  variables?: V;
  headers?: Record<string, any>;
  signal?: any; // should be AbortSignal, but the Typescript linter raises an error for this
}): Promise<T> => {
  const graphQLClient = new GraphQLClient(
    process.env.NEXT_PUBLIC_WHITELABEL_API_URL || '',
    {
      headers,
      signal,
    },
  );

  return graphQLClient.request<T>(query, variables);
};
